export const BASE_QUOTE_TYPES = ["roof", "wall", "floor"];

export const EXTRA_QUOTE_TYPES = ["beams", "flooring_sheets"];

export const FILE_ONLY_QUOTE_TYPES = ["beams", "flooring_sheets"];

export const QUOTE_LABELS = {
    roof: "Roof",
    wall: "Wall",
    floor: "Floor",
    timber: "Timber",
    beams: "Beams",
    flooring_sheets: "Flooring Sheets",
};

export const QUOTE_SHORT_CODES = {
    roof: "R",
    wall: "W",
    floor: "F",
    timber: "T",
    beams: "B",
    flooring_sheets: "FS",
};

export const QUOTE_ORDER = {
    roof: 3,
    wall: 4,
    floor: 5,
    beams: 0,
    flooring_sheets: 1,
    timber: 2,
};

export const isFileOnlyQuoteType = (quoteType) => {
    return FILE_ONLY_QUOTE_TYPES.includes(quoteType);
};

export const getEnabledExtraQuoteTypes = (company) => {
    const extras = company?.settings?.enabled_extra_quote_types;

    if (!Array.isArray(extras)) return [];

    return extras.filter((type) => EXTRA_QUOTE_TYPES.includes(type));
};

export const getEnabledQuoteTypes = (company) => {
    return [...BASE_QUOTE_TYPES, ...getEnabledExtraQuoteTypes(company)];
};

export const getQuoteLabel = (quoteType) => {
    return QUOTE_LABELS[quoteType] || quoteType;
};

export const sortQuoteTypes = (a, b) => {
    return (QUOTE_ORDER[a] ?? 99) - (QUOTE_ORDER[b] ?? 99);
};

export const sortQuotes = (a, b) => {
    const typeOrder = sortQuoteTypes(a.quote_type, b.quote_type);
    if (typeOrder !== 0) return typeOrder;

    return (a.child_unique_id || "").localeCompare(b.child_unique_id || "");
};